import { Component, effect, inject, OnInit } from '@angular/core';
import {
  baseCssConfigStyle,
  BaseCssProperties,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { IconCacheService } from '@finxone-platform/shared/services';
import { Store } from '@ngxs/store';
import { buildHandleBarModel } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { Subject, takeUntil } from 'rxjs';
import Handlebars from 'handlebars';
import { TooltipComponent } from 'libs/ui-components/src/lib/tooltip/tooltip.component';

@Component({
  selector: 'finxone-web-frontend-tooltip-widget',
  templateUrl: './tooltip-widget.component.html',
  imports: [TooltipComponent],
})
export class TooltipWidgetComponent implements OnInit {
  @AutoDestroy private readonly destroy$: Subject<void> = new Subject<void>();
  private readonly configService = inject(ConfigService);
  private readonly store = inject(Store);
  private readonly countriesCurrenciesService = inject(CountriesCurrenciesService);
  private readonly iconCacheService = inject(IconCacheService);
  private cssVars: Record<string, string> = {};
  private widgetAttributes: UiZoneWidgetAttributeConfig;

  public tooltipContentTemplate: HandlebarsTemplateDelegate;
  public tooltipBorderRadiusClass = '';
  public tooltipTextStyleClass = '';
  public renderedTemplate = '';
  public icon = '';
  public iconStyles: baseCssConfigStyle;

  constructor(private readonly dataIn: ProviderClass<UiZoneWidgetAttributeConfig>) {
    effect(() => {
      const globalCssVariables = this.configService.globalCssVariables();
      if (globalCssVariables) {
        this.cssVars = globalCssVariables;
        this.tooltipTextStyleClass = this.getCssVariableValue('--tooltipTextStyleClass');
        this.tooltipBorderRadiusClass = this.getCssVariableValue('--tooltipBorderRadiusClass');
      }
    });
  }

  ngOnInit(): void {
    if (this.dataIn?.attri) {
      this.widgetAttributes = this.dataIn.attri;
      const content = this.widgetAttributes.widgetProperties.textContent;
      this.buildHandlebarModelAndCompileTemplate(content);
      this.icon = this.widgetAttributes.widgetProperties.icon ?? 'info';
      this.iconStyles = this.configService.getSpecificBaseCssStyle(this.widgetAttributes, [
        BaseCssProperties.ICON_SIZE,
        BaseCssProperties.ICON_COLOR,
      ]);
    }
  }

  private buildHandlebarModelAndCompileTemplate(content: string): void {
    this.tooltipContentTemplate = Handlebars.compile(content);
    buildHandleBarModel(
      this.store,
      content,
      this.countriesCurrenciesService,
      this.iconCacheService,
      undefined,
      undefined,
      undefined,
      undefined,
      true, // to avoid auto refresh of state data (accounts listing etc)
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.renderedTemplate = this.tooltipContentTemplate(model);
      });
  }

  private getCssVariableValue(variableName: string): string {
    return this.cssVars[variableName];
  }
}
